/**
 * Copyright © 2023 650 Industries.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './location/install';
// IMPORT POSITION MATTERS FOR FAST REFRESH ON WEB
import './effects';
// vvv EVERYTHING ELSE vvv
import './async-require';
